import restClient from '../restClient';
export const SUBMITTED_CORPORATE_INSTITUTION_TYPE = 'SUBMITTED_CORPORATE_INSTITUTION_TYPE';
export const SUBMITTING_CORPORATE_INSTITUTION_TYPE = 'SUBMITTING_CORPORATE_INSTITUTION_TYPE';
export const FAILED_TO_SUBMIT_CORPORATE_INSTITUTION_FAILED = 'FAILED_TO_SUBMIT_CORPORATE_INSTITUTION_FAILED';
const corporateInstitutionTypeSubmitted = () => ({
  type: SUBMITTED_CORPORATE_INSTITUTION_TYPE
});
const submittingCorporateInstitutionType = () => ({
  type: SUBMITTING_CORPORATE_INSTITUTION_TYPE
});
const failedToSubmitCorporateInstitution = error => ({
  error,
  type: FAILED_TO_SUBMIT_CORPORATE_INSTITUTION_FAILED
});
export const doSubmitCorporateInstitutionTypeSection = corporateInstitutionType => async dispatch => {
  dispatch(submittingCorporateInstitutionType());
  try {
    await restClient.submitCorporateInstitutionTypeSection(corporateInstitutionType);
    dispatch(corporateInstitutionTypeSubmitted());
  } catch (error) {
    dispatch(failedToSubmitCorporateInstitution(error));
  }
};